import { pickBy } from 'lodash';
import qs from 'qs';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const getUpdatesListUrl = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/updates/list', {
    params: { ...parsedPayload, ...pickDevParams },
  });
};

export const deleteUpdatesUrl = (updates) => axiosInstance.post('/updates/delete', qs.stringify({ updates, ...pickDevParams }));
